export const reservationConfirmationPageConstants = {
    thankYouMsg: "Thank you, ",
    confirmationMsg: (reservationNumber) => `Your reservation number is #${reservationNumber}.`,
    cancelConfirmationMsg: (reservationId) => `Reservation #${reservationId} has been cancelled.`,
    timelineHeader: "What happens next:",
    newReservationButtonLabel: "Place another reservation",
    editInfoMessage: "Check back again to see contract pricing. You can edit your reservation until ordering opens. Orders will not be finalized or shipped until they have been confirmed and FDA approves or authorizes the 2025-2026 vaccine formula for Moderna COVID-19 Vaccines.",
    editReservationButtonLabel: "Edit reservation"
}